import { render, staticRenderFns } from "./ReleaseNotes.vue?vue&type=template&id=9bbaabac&scoped=true&"
import script from "./ReleaseNotes.vue?vue&type=script&lang=js&"
export * from "./ReleaseNotes.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseNotes.vue?vue&type=style&index=0&id=9bbaabac&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbaabac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/fiksucity/city-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bbaabac')) {
      api.createRecord('9bbaabac', component.options)
    } else {
      api.reload('9bbaabac', component.options)
    }
    module.hot.accept("./ReleaseNotes.vue?vue&type=template&id=9bbaabac&scoped=true&", function () {
      api.rerender('9bbaabac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ReleaseNotes.vue"
export default component.exports